import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  canonical?: string;
}

const SEO = ({ 
  title = "Neil AI Global Solutions – AI Automation & PUDU Robotics Dealer",
  description = "Go fully autonomous with Neil AI — offering robotics, AI voice automation, CRM systems & digital integration for businesses nationwide.",
  keywords = "AI automation, PUDU robotics, service robots, delivery robots, cleaning robots, voice automation, CRM integration, business automation, AI solutions, robotics dealer",
  ogImage = "https://storage.googleapis.com/gpt-engineer-file-uploads/8SEUVb8JvPcIZjhsVe7dXyjWUY22/social-images/social-1762627978213-neil ai gs logo new.png",
  canonical = "https://neilaiglobalsolutionsllc.net/"
}: SEOProps) => {
  const location = useLocation();

  useEffect(() => {
    // Update title
    document.title = title;

    // Update meta tags
    const metaTags = {
      description,
      keywords,
      'og:title': title,
      'og:description': description,
      'og:image': ogImage,
      'og:url': canonical || window.location.href,
      'twitter:title': title,
      'twitter:description': description,
      'twitter:image': ogImage,
    };

    Object.entries(metaTags).forEach(([key, value]) => {
      const attribute = key.startsWith('og:') || key.startsWith('twitter:') ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${key}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', value);
    });

    // Update canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonical || window.location.href);

    // Track page view
    if (window.gtag) {
      window.gtag('config', 'G-XXXXXXXXXX', {
        page_path: location.pathname,
      });
    }

    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [title, description, keywords, ogImage, canonical, location.pathname]);

  return null;
};

export default SEO;
